import { render } from "./step3.vue?vue&type=template&id=8264a630"
import script from "./step3.vue?vue&type=script&lang=js"
export * from "./step3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__